module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-overlayer"
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.barrier_name))]), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "width": "640px",
      "height": "480px",
      "display": "block"
    },
    attrs: {
      "id": "video_player"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.permanent_open_bool == false) ? _c('button', {
    staticClass: "button small orange with-icon",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "title": "Kinyitás"
    },
    on: {
      "click": function($event) {
        return _vm.opening(_vm.barrier_id, _vm.barrier_name, _vm.refresh)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock-open"
  }), _vm._v("Kinyitás")]) : _vm._e(), _vm._v(" "), (_vm.permanent_open_bool == false && _vm.nciom_control_seq_id == false) ? _c('button', {
    staticClass: "button small orange with-icon",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "title": "Tartós nyitás"
    },
    on: {
      "click": function($event) {
        return _vm.permanentOpening(_vm.barrier_id, 0, _vm.barrier_name, _vm.refresh)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock-open"
  }), _vm._v("Tartós nyitás")]) : _vm._e(), _vm._v(" "), (_vm.permanent_open_bool != false) ? _c('button', {
    staticClass: "button small orange with-icon",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "title": "Normál üzem időpont"
    },
    on: {
      "click": function($event) {
        return _vm.normalOperationDatetime(_vm.barrier_id, _vm.refresh)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v("Normál üzem időpont")]) : _vm._e(), _vm._v(" "), (_vm.permanent_open_bool != false) ? _c('button', {
    staticClass: "button small orange with-icon",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "title": "Normál üzem azonnal"
    },
    on: {
      "click": function($event) {
        return _vm.normalOperationNow(_vm.barrier_id, _vm.barrier_name, _vm.refresh)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v("Normál üzem azonnal")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b00d6e38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/remote_open/camera_view_popup.vue
// module id = 325
// module chunks = 0